import { useState } from 'react';

import { useBulkDeployPageContext } from 'ion-experimental/app/bulk-deploy/BulkDeployPageContext';
import { useBulkDeployModalContext, BULK_DEPLOY_MODALS } from 'ion-experimental/app/bulk-deploy/BulkDeployModalContext';

export default function useConfirmDeployModalProps() {
  const { selectedPipelineIds, handleStartDeployment } = useBulkDeployPageContext();
  const { activeModal, onOpenModal, onCloseModal } = useBulkDeployModalContext();

  const [confirmInputValue, setConfirmInputValue] = useState('');

  const selectedCount = selectedPipelineIds.size;

  const onClose = () => {
    onCloseModal();
    setConfirmInputValue('');
  };

  const onConfirm = () => {
    // Hand off from the confirm modal to the progress modal, then kick off the deploy
    setConfirmInputValue('');
    onOpenModal(BULK_DEPLOY_MODALS.DEPLOY_PROGRESS);
    handleStartDeployment();
  };

  return {
    DialogProps: {
      open: activeModal === BULK_DEPLOY_MODALS.CONFIRM_BULK_DEPLOY,
      onClose: onClose,
      fullWidth: true,
      maxWidth: 'sm',
    },
    selectedCount,
    onClose: onClose,
    confirmDisabled: confirmInputValue.toLowerCase() !== 'deploy',
    onConfirm,
    setConfirmInputValue,
  };
}
